import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';

function GaugeBar({ label, spent, cap, unit }: { label: string; spent: number; cap: number; unit: string }) {
  const pct = cap > 0 ? Math.min((spent / cap) * 100, 100) : 0;
  const color = pct > 90 ? 'bg-tower-danger' : pct > 70 ? 'bg-tower-warning' : 'bg-tower-success';

  return (
    <div className="space-y-1">
      <div className="flex justify-between text-xs">
        <span className="text-tower-muted">{label}</span>
        <span className="text-tower-text font-mono">
          {unit === '$' ? `$${spent.toFixed(2)} / $${cap.toFixed(2)}` : `${spent.toFixed(0)}${unit} / ${cap.toFixed(0)}${unit}`}
        </span>
      </div>
      <div className="h-2 bg-tower-border rounded-full overflow-hidden">
        <div className={`h-full ${color} rounded-full transition-all duration-500`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export function BudgetGaugeWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const { totalBudget } = journal;

  return (
    <div className="p-3 space-y-3">
      <GaugeBar label="Dollars" spent={totalBudget.dollars.spent} cap={totalBudget.dollars.hardCap} unit="$" />
      <GaugeBar label="Active Time" spent={totalBudget.wallClock.activeSecondsUsed} cap={totalBudget.wallClock.activeSecondsCap} unit="s" />
      <GaugeBar
        label="Human Interrupts"
        spent={totalBudget.humanAttention.interruptsUsed}
        cap={totalBudget.humanAttention.interruptsAllowed}
        unit=""
      />
      <div className="border-t border-tower-border pt-2 text-xs text-tower-muted">
        Soft cap at ${totalBudget.dollars.softCap.toFixed(2)} &middot; Model downshift triggers at 90%
      </div>
    </div>
  );
}
